export default __webpack_public_path__ + "static/media/Rectangles_05.0311b57c.png";